// extracted by mini-css-extract-plugin
module.exports = {"Slide":"Slide_Slide__gTOmP","fadein":"Slide_fadein__3cYmG"};